import {
  PayableImportBatchConfiguration,
  PayableStatus,
  PayerApprovalStatus
} from "@wingspanhq/wingspan-api-sdk";

import {
  PAYABLE_IMPORT_BATCH_STATUS_CONFIGURATION,
  PayableImportBatchStatus
} from "../constants/payableImportBatchStatus";

/**
 * The status option the payer picked, read back off the batch configuration.
 *
 * The API defaults `payableStatus` to the sentinel `StatusUnspecified`, which
 * is not a member of the SDK enum and means "the backend picks" — rendering it
 * raw would show users an internal token.
 */
export const selectorPayableImportBatchStatusLabel = (
  configuration?: PayableImportBatchConfiguration
): string => {
  const payableStatus = configuration?.payableStatus;

  if (!payableStatus || String(payableStatus) === "StatusUnspecified") {
    return "Default";
  }

  const match = Object.keys(PAYABLE_IMPORT_BATCH_STATUS_CONFIGURATION).find(
    option => {
      const candidate =
        PAYABLE_IMPORT_BATCH_STATUS_CONFIGURATION[
          option as PayableImportBatchStatus
        ];

      return (
        candidate.payableStatus === payableStatus &&
        (candidate.payerApprovalStatus === undefined ||
          candidate.payerApprovalStatus === configuration?.payerApprovalStatus)
      );
    }
  );

  if (match) {
    return match;
  }

  // A status the picker cannot produce (set through the API, say) still has to
  // read as something.
  return payableStatus === PayableStatus.PAID_OFF_PLATFORM
    ? PayableImportBatchStatus.Paid
    : configuration?.payerApprovalStatus === PayerApprovalStatus.APPROVED
      ? PayableImportBatchStatus.Approved
      : String(payableStatus);
};
